//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('doDataImps', {
//        templateUrl: 'views/components/views/doDataImps/doDataImps.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'ttGridFactory', function (stateService, ttGridFactory) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            vm.model = {
//                gridReady: true
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_dodataimps_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            })
//                .setToolbar({ wrapping: true })
//                .setCustomToolbarButtons([{
//                    name: 'dodataimps_new',
//                    text: 'dodataimps_new',
//                    func: () => stateService.go('dataimps'),
//                    icon: 'fa-plus',
//                    cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
//                    translate: true
//                }])
//                .setLoadDataFunction({
//                    method: 3173,
//                    parameters: {}
//                });

//            // #endregion VARIABLES & DEFINITIONS
            
//        }]
//    });
//})();
